import { memo, useEffect } from "react";
import type { Root } from "react-dom/client";
import { createRoot } from "react-dom/client";

import * as mainLoadingCss from "@Components/MainLoading/MainLoading.module.css";
import { Modal } from "@Components/Modal";

import MainLoading from "../MainLoading";
import { defaultToTrue } from "./Helpers";

export interface IMainLoadingModule {
    hideMainLoading?: boolean;
}

let loadingParentDiv: HTMLDivElement | null = null;
let loadingRoot: Root = null;

const cancelLoading = (): void => {
    if (loadingRoot) {
        loadingRoot.unmount();
        loadingRoot = null;
        document.body.removeChild(loadingParentDiv);
        loadingParentDiv = null;
        document.body.style.overflow = null;
    }
};

// export function shouldShowMainLoading(props: IMainLoadingModule): boolean;
// export function shouldShowMainLoading(props: IMainLoadingModule, event: React.MouseEvent<HTMLElement>): boolean;
export function shouldShowMainLoading(
    props?: IMainLoadingModule,
    event?: React.MouseEvent<HTMLElement>,
): boolean {
    if (event) {
        if (event.ctrlKey || event.shiftKey || event.button === 1 || event.button === 2 || event.metaKey) {
            return false;
        }
    }

    if (props && props.hideMainLoading === true) {
        return false;
    }

    return true;
}

// export function showMainLoading(): void;
// export function showMainLoading(props: IMainLoadingModule): void;
// export function showMainLoading(props: IMainLoadingModule, event: React.MouseEvent<HTMLElement>): void;
export function showMainLoading(props?: IMainLoadingModule, event?: React.MouseEvent<HTMLElement>): void {
    if (shouldShowMainLoading(props, event) === false || loadingRoot) {
        return;
    }

    if (!loadingParentDiv) {
        loadingParentDiv = document.createElement("div");
        document.body.appendChild(loadingParentDiv);
        document.body.style.overflow = "hidden";
    }

    const onEscPress = (ev: KeyboardEvent): any => {
        if (ev.keyCode === 27) {
            cancelLoading();
        }
    };

    const modal = (
        <Modal
            className={mainLoadingCss.modalMainLoading}
            isOpen
            closeOnBlur={false}
            closeOnEsc={false}
            onKeyDown={onEscPress}
            hideCloseButton
        >
            <MainLoading />
        </Modal>
    );

    loadingRoot = createRoot(loadingParentDiv);
    loadingRoot.render(modal);
}

export function hideMainLoading() {
    cancelLoading();
}

export const MainLoadingModal = memo(() => {
    useEffect(() => {
        showMainLoading();

        return hideMainLoading();
    }, []);

    return null;
}, defaultToTrue);
